/**
 * Middle School Complete Vocabulary - Part O-Z (O-Z部分词汇)
 * 补充词汇约350个
 */

import { VocabularyWord } from './vocabulary';

export const vocabularyOZ: VocabularyWord[] = [
  // O 部分词汇
  {
    id: 'object', word: 'object', phoneticUS: '/ˈɑbdʒekt/', phoneticUK: '/ˈɒbdʒekt/',
    meaning: '物体', example: 'An object.', exampleTranslation: '一个物体。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📦'
  },
  {
    id: 'occur', word: 'occur', phoneticUS: '/əˈkɜr/', phoneticUK: '/əˈkɜ/',
    meaning: '发生', example: 'Problems occur.', exampleTranslation: '问题发生了。',
    category: 'actions', difficulty: 'hard', grade: '9', level: 'middle', image: '⚠️'
  },
  {
    id: 'ocean', word: 'ocean', phoneticUS: '/ˈoʊʃn/', phoneticUK: '/ˈəʊʃn/',
    meaning: '海洋', example: 'Blue ocean.', exampleTranslation: '蓝色的海洋。',
    category: 'nature', difficulty: 'medium', grade: '8', level: 'middle', image: '🌊'
  },
  {
    id: 'offer', word: 'offer', phoneticUS: '/ˈɑfər/', phoneticUK: '/ˈɒfə/',
    meaning: '提供', example: 'Offer help.', exampleTranslation: '提供帮助。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '🤝'
  },
  {
    id: 'office', word: 'office', phoneticUS: '/ˈɑfɪs/', phoneticUK: '/ˈɒfɪs/',
    meaning: '办公室', example: 'Work in an office.', exampleTranslation: '在办公室工作。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🏢'
  },
  {
    id: 'officer', word: 'officer', phoneticUS: '/ˈɑfɪsər/', phoneticUK: '/ˈɒfɪsə/',
    meaning: '军官；警官', example: 'A police officer.', exampleTranslation: '警官。',
    category: 'jobs', difficulty: 'medium', grade: '9', level: 'middle', image: '👮'
  },
  {
    id: 'often', word: 'often', phoneticUS: '/ˈɑfən/', phoneticUK: '/ˈɒfən/',
    meaning: '经常', example: 'I often go.', exampleTranslation: '我经常去。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🔄'
  },
  {
    id: 'oil', word: 'oil', phoneticUS: '/ɔɪl/', phoneticUK: '/ɔɪl/',
    meaning: '油', example: 'Cooking oil.', exampleTranslation: '食用油。',
    category: 'food', difficulty: 'easy', grade: '8', level: 'middle', image: '🛢️'
  },
  {
    id: 'old', word: 'old', phoneticUS: '/oʊld/', phoneticUK: '/əʊld/',
    meaning: '老的', example: 'Old book.', exampleTranslation: '旧书。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'on', word: 'on', phoneticUS: '/ɑn/', phoneticUK: '/ɒn/',
    meaning: '在...上', example: 'On the table.', exampleTranslation: '在桌子上。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📍'
  },
  {
    id: 'once', word: 'once', phoneticUS: '/wʌns/', phoneticUK: '/wʌns/',
    meaning: '一次', example: 'Once a week.', exampleTranslation: '每周一次。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '1️⃣'
  },
  {
    id: 'one', word: 'one', phoneticUS: '/wʌn/', phoneticUK: '/wʌn/',
    meaning: '一', example: 'One apple.', exampleTranslation: '一个苹果。',
    category: 'numbers', difficulty: 'easy', grade: '7', level: 'middle', image: '1️⃣'
  },
  {
    id: 'only', word: 'only', phoneticUS: '/ˈoʊnli/', phoneticUK: '/ˈəʊnli/',
    meaning: '唯一的', example: 'Only one.', exampleTranslation: '只有一个。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🎯'
  },
  {
    id: 'open', word: 'open', phoneticUS: '/ˈoʊpən/', phoneticUK: '/ˈəʊpən/',
    meaning: '打开', example: 'Open the door.', exampleTranslation: '开门。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚪'
  },
  {
    id: 'or', word: 'or', phoneticUS: '/ɔr/', phoneticUK: '/ɔ/',
    meaning: '或者', example: 'Tea or coffee?', exampleTranslation: '茶还是咖啡？',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '❓'
  },
  {
    id: 'orange', word: 'orange', phoneticUS: '/ˈɔrɪndʒ/', phoneticUK: '/ˈɒrɪndʒ/',
    meaning: '橙子；橙色', example: 'Eat an orange.', exampleTranslation: '吃橙子。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🍊'
  },
  {
    id: 'order', word: 'order', phoneticUS: '/ˈɔrdər/', phoneticUK: '/ˈɔdə/',
    meaning: '秩序；命令', example: 'Keep order.', exampleTranslation: '保持秩序。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📋'
  },
  {
    id: 'ordinary', word: 'ordinary', phoneticUS: '/ˈɔrdənəri/', phoneticUK: '/ˈɔdnəri/',
    meaning: '普通的', example: 'An ordinary day.', exampleTranslation: '普通的一天。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📅'
  },
  {
    id: 'organize', word: 'organize', phoneticUS: '/ˈɔrgənaɪz/', phoneticUK: '/ˈɔgənaɪz/',
    meaning: '组织', example: 'Organize a party.', exampleTranslation: '组织聚会。',
    category: 'actions', difficulty: 'hard', grade: '9', level: 'middle', image: '🎉'
  },
  {
    id: 'other', word: 'other', phoneticUS: '/ˈʌðər/', phoneticUK: '/ˈʌðə/',
    meaning: '其他的', example: 'Other books.', exampleTranslation: '其他书。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📚'
  },
  {
    id: 'our', word: 'our', phoneticUS: '/aʊər/', phoneticUK: '/aʊə/',
    meaning: '我们的', example: 'Our school.', exampleTranslation: '我们的学校。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🏫'
  },
  {
    id: 'out', word: 'out', phoneticUS: '/aʊt/', phoneticUK: '/aʊt/',
    meaning: '外面', example: 'Go out.', exampleTranslation: '出去。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '🚶'
  },
  {
    id: 'outside', word: 'outside', phoneticUS: '/ˈaʊtsaɪd/', phoneticUK: '/ˈaʊtsaɪd/',
    meaning: '在外面', example: 'Outside the house.', exampleTranslation: '在房子外面。',
    category: 'directions', difficulty: 'easy', grade: '7', level: 'middle', image: '🌳'
  },
  {
    id: 'over', word: 'over', phoneticUS: '/ˈoʊvər/', phoneticUK: '/ˈəʊvə/',
    meaning: '超过；在...上方', example: 'Over there.', exampleTranslation: '在那边。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👆'
  },
  {
    id: 'own', word: 'own', phoneticUS: '/oʊn/', phoneticUK: '/əʊn/',
    meaning: '自己的', example: 'My own book.', exampleTranslation: '我自己的书。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '📚'
  },

  // P 部分词汇
  {
    id: 'page', word: 'page', phoneticUS: '/peɪdʒ/', phoneticUK: '/peɪdʒ/',
    meaning: '页', example: 'Turn the page.', exampleTranslation: '翻页。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📄'
  },
  {
    id: 'pain', word: 'pain', phoneticUS: '/peɪn/', phoneticUK: '/peɪn/',
    meaning: '痛苦', example: 'No pain, no gain.', exampleTranslation: '不劳无获。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '💪'
  },
  {
    id: 'paint', word: 'paint', phoneticUS: '/peɪnt/', phoneticUK: '/peɪnt/',
    meaning: '绘画', example: 'Paint a picture.', exampleTranslation: '画画。',
    category: 'hobbies', difficulty: 'easy', grade: '8', level: 'middle', image: '🎨'
  },
  {
    id: 'pair', word: 'pair', phoneticUS: '/per/', phoneticUK: '/peə/',
    meaning: '一对', example: 'A pair of shoes.', exampleTranslation: '一双鞋。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👟'
  },
  {
    id: 'palace', word: 'palace', phoneticUS: '/ˈpælɪs/', phoneticUK: '/ˈpælɪs/',
    meaning: '宫殿', example: 'A beautiful palace.', exampleTranslation: '美丽的宫殿。',
    category: 'places', difficulty: 'medium', grade: '9', level: 'middle', image: '🏰'
  },
  {
    id: 'pale', word: 'pale', phoneticUS: '/peɪl/', phoneticUK: '/peɪl/',
    meaning: '苍白的', example: 'Pale face.', exampleTranslation: '苍白的脸。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '😔'
  },
  {
    id: 'paper', word: 'paper', phoneticUS: '/ˈpeɪpər/', phoneticUK: '/ˈpeɪpə/',
    meaning: '纸', example: 'Write on paper.', exampleTranslation: '在纸上写。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '📄'
  },
  {
    id: 'parent', word: 'parent', phoneticUS: '/ˈperənt/', phoneticUK: '/ˈpeərənt/',
    meaning: '父母', example: 'My parents.', exampleTranslation: '我的父母。',
    category: 'family', difficulty: 'easy', grade: '7', level: 'middle', image: '👨👩'
  },
  {
    id: 'park', word: 'park', phoneticUS: '/pɑrk/', phoneticUK: '/pɑk/',
    meaning: '公园', example: 'Go to the park.', exampleTranslation: '去公园。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🌳'
  },
  {
    id: 'part', word: 'part', phoneticUS: '/pɑrt/', phoneticUK: '/pɑt/',
    meaning: '部分', example: 'Part of the story.', exampleTranslation: '故事的一部分。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📖'
  },
  {
    id: 'party', word: 'party', phoneticUS: '/ˈpɑrti/', phoneticUK: '/ˈpɑti/',
    meaning: '聚会', example: 'Birthday party.', exampleTranslation: '生日聚会。',
    category: 'daily_life', difficulty: 'easy', grade: '7', level: 'middle', image: '🎉'
  },
  {
    id: 'pass', word: 'pass', phoneticUS: '/pæs/', phoneticUK: '/pæs/',
    meaning: '通过', example: 'Pass the exam.', exampleTranslation: '通过考试。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '✅'
  },
  {
    id: 'passage', word: 'passage', phoneticUS: '/ˈpæsɪdʒ/', phoneticUK: '/ˈpæsɪdʒ/',
    meaning: '通道；段落', example: 'Read the passage.', exampleTranslation: '阅读段落。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📖'
  },
  {
    id: 'passenger', word: 'passenger', phoneticUS: '/ˈpæsəndʒər/', phoneticUK: '/ˈpæsɪndʒə/',
    meaning: '乘客', example: 'Bus passengers.', exampleTranslation: '公交车乘客。',
    category: 'travel', difficulty: 'medium', grade: '8', level: 'middle', image: '🚌'
  },
  {
    id: 'passport', word: 'passport', phoneticUS: '/ˈpæspɔrt/', phoneticUK: '/ˈpɑspɔt/',
    meaning: '护照', example: 'Show your passport.', exampleTranslation: '出示护照。',
    category: 'travel', difficulty: 'medium', grade: '8', level: 'middle', image: '🛂'
  },
  {
    id: 'past', word: 'past', phoneticUS: '/pæst/', phoneticUK: '/pæst/',
    meaning: '过去的', example: 'In the past.', exampleTranslation: '在过去。',
    category: 'time', difficulty: 'easy', grade: '7', level: 'middle', image: '⏮️'
  },
  {
    id: 'path', word: 'path', phoneticUS: '/pæθ/', phoneticUK: '/pæθ/',
    meaning: '路径', example: 'Follow the path.', exampleTranslation: '跟随路径。',
    category: 'directions', difficulty: 'medium', grade: '9', level: 'middle', image: '🛤️'
  },
  {
    id: 'pay', word: 'pay', phoneticUS: '/peɪ/', phoneticUK: '/peɪ/',
    meaning: '支付', example: 'Pay the bill.', exampleTranslation: '付账单。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '💰'
  },
  {
    id: 'peace', word: 'peace', phoneticUS: '/piːs/', phoneticUK: '/piːs/',
    meaning: '和平', example: 'Peace and love.', exampleTranslation: '和平与爱。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '☮️'
  },
  {
    id: 'pen', word: 'pen', phoneticUS: '/pen/', phoneticUK: '/pen/',
    meaning: '钢笔', example: 'Use a pen.', exampleTranslation: '用钢笔。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '🖊️'
  },
  {
    id: 'pencil', word: 'pencil', phoneticUS: '/ˈpensl/', phoneticUK: '/ˈpensl/',
    meaning: '铅笔', example: 'Draw with a pencil.', exampleTranslation: '用铅笔画画。',
    category: 'school', difficulty: 'easy', grade: '7', level: 'middle', image: '✏️'
  },
  {
    id: 'people', word: 'people', phoneticUS: '/ˈpiːpl/', phoneticUK: '/ˈpiːpl/',
    meaning: '人们', example: 'Many people.', exampleTranslation: '很多人。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👥'
  },
  {
    id: 'perhaps', word: 'perhaps', phoneticUS: '/pərˈhæps/', phoneticUK: '/pəˈhæps/',
    meaning: '可能', example: 'Perhaps tomorrow.', exampleTranslation: '可能明天。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '🤔'
  },
  {
    id: 'period', word: 'period', phoneticUS: '/ˈpɪriəd/', phoneticUK: '/ˈpɪriəd/',
    meaning: '时期', example: 'A long period.', exampleTranslation: '很长时间。',
    category: 'time', difficulty: 'medium', grade: '9', level: 'middle', image: '📅'
  },
  {
    id: 'person', word: 'person', phoneticUS: '/ˈpɜrsən/', phoneticUK: '/ˈpɜsən/',
    meaning: '人', example: 'A kind person.', exampleTranslation: '善良的人。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '👤'
  },
  {
    id: 'personal', word: 'personal', phoneticUS: '/ˈpɜrsənəl/', phoneticUK: '/ˈpɜsənəl/',
    meaning: '个人的', example: 'Personal opinion.', exampleTranslation: '个人意见。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '👤'
  },
  {
    id: 'pet', word: 'pet', phoneticUS: '/pet/', phoneticUK: '/pet/',
    meaning: '宠物', example: 'I have a pet.', exampleTranslation: '我有宠物。',
    category: 'animals', difficulty: 'easy', grade: '7', level: 'middle', image: '🐕'
  },
  {
    id: 'phone', word: 'phone', phoneticUS: '/foʊn/', phoneticUK: '/fəʊn/',
    meaning: '电话', example: 'Call me on the phone.', exampleTranslation: '给我打电话。',
    category: 'technology', difficulty: 'easy', grade: '7', level: 'middle', image: '📞'
  },
  {
    id: 'photo', word: 'photo', phoneticUS: '/ˈfoʊtoʊ/', phoneticUK: '/ˈfəʊtəʊ/',
    meaning: '照片', example: 'Take a photo.', exampleTranslation: '拍照片。',
    category: 'hobbies', difficulty: 'easy', grade: '7', level: 'middle', image: '📷'
  },
  {
    id: 'physics', word: 'physics', phoneticUS: '/ˈfɪzɪks/', phoneticUK: '/ˈfɪzɪks/',
    meaning: '物理', example: 'Study physics.', exampleTranslation: '学习物理。',
    category: 'school', difficulty: 'medium', grade: '8', level: 'middle', image: '⚛️'
  },
  {
    id: 'pick', word: 'pick', phoneticUS: '/pɪk/', phoneticUK: '/pɪk/',
    meaning: '挑选', example: 'Pick one.', exampleTranslation: '挑一个。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '✋'
  },
  {
    id: 'picture', word: 'picture', phoneticUS: '/ˈpɪktʃər/', phoneticUK: '/ˈpɪktʃə/',
    meaning: '图片', example: 'Draw a picture.', exampleTranslation: '画图。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🖼️'
  },
  {
    id: 'piece', word: 'piece', phoneticUS: '/piːs/', phoneticUK: '/piːs/',
    meaning: '片；块', example: 'A piece of cake.', exampleTranslation: '一块蛋糕。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🍰'
  },
  {
    id: 'pig', word: 'pig', phoneticUS: '/pɪɡ/', phoneticUK: '/pɪɡ/',
    meaning: '猪', example: 'A pink pig.', exampleTranslation: '粉色的猪。',
    category: 'animals', difficulty: 'easy', grade: '7', level: 'middle', image: '🐷'
  },
  {
    id: 'pill', word: 'pill', phoneticUS: '/pɪl/', phoneticUK: '/pɪl/',
    meaning: '药丸', example: 'Take a pill.', exampleTranslation: '吃药丸。',
    category: 'body', difficulty: 'medium', grade: '9', level: 'middle', image: '💊'
  },
  {
    id: 'pilot', word: 'pilot', phoneticUS: '/ˈpaɪlət/', phoneticUK: '/ˈpaɪlət/',
    meaning: '飞行员', example: 'A brave pilot.', exampleTranslation: '勇敢的飞行员。',
    category: 'jobs', difficulty: 'medium', grade: '9', level: 'middle', image: '👨‍✈️'
  },
  {
    id: 'pineapple', word: 'pineapple', phoneticUS: '/ˈpaɪnæpl/', phoneticUK: '/ˈpaɪnæpl/',
    meaning: '菠萝', example: 'Eat pineapple.', exampleTranslation: '吃菠萝。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🍍'
  },
  {
    id: 'pink', word: 'pink', phoneticUS: '/pɪŋk/', phoneticUK: '/pɪŋk/',
    meaning: '粉色', example: 'Pink dress.', exampleTranslation: '粉色裙子。',
    category: 'colors', difficulty: 'easy', grade: '7', level: 'middle', image: '🩷'
  },
  {
    id: 'pioneer', word: 'pioneer', phoneticUS: '/ˈpaɪənɪr/', phoneticUK: '/ˈpaɪənɪə/',
    meaning: '先驱', example: 'A great pioneer.', exampleTranslation: '伟大的先驱。',
    category: 'abstract', difficulty: 'hard', grade: '9', level: 'middle', image: '🌟'
  },
  {
    id: 'place', word: 'place', phoneticUS: '/pleɪs/', phoneticUK: '/pleɪs/',
    meaning: '地方', example: 'Go to a place.', exampleTranslation: '去一个地方。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '📍'
  },
  {
    id: 'plain', word: 'plain', phoneticUS: '/pleɪn/', phoneticUK: '/pleɪn/',
    meaning: '平原；简单的', example: 'Plain clothes.', exampleTranslation: '朴素的衣服。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '👕'
  },
  {
    id: 'plan', word: 'plan', phoneticUS: '/plæn/', phoneticUK: '/plæn/',
    meaning: '计划', example: 'Make a plan.', exampleTranslation: '做计划。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '📋'
  },
  {
    id: 'plane', word: 'plane', phoneticUS: '/pleɪn/', phoneticUK: '/pleɪn/',
    meaning: '飞机', example: 'By plane.', exampleTranslation: '坐飞机。',
    category: 'transport', difficulty: 'easy', grade: '7', level: 'middle', image: '✈️'
  },
  {
    id: 'plant', word: 'plant', phoneticUS: '/plænt/', phoneticUK: '/plænt/',
    meaning: '植物；种植', example: 'Plant a tree.', exampleTranslation: '种树。',
    category: 'nature', difficulty: 'easy', grade: '7', level: 'middle', image: '🌱'
  },
  {
    id: 'play', word: 'play', phoneticUS: '/pleɪ/', phoneticUK: '/pleɪ/',
    meaning: '玩耍', example: 'Play games.', exampleTranslation: '玩游戏。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '🎮'
  },
  {
    id: 'player', word: 'player', phoneticUS: '/ˈpleɪər/', phoneticUK: '/ˈpleɪə/',
    meaning: '运动员', example: 'A good player.', exampleTranslation: '好的运动员。',
    category: 'sports', difficulty: 'easy', grade: '8', level: 'middle', image: '⚽'
  },
  {
    id: 'playground', word: 'playground', phoneticUS: '/ˈpleɪɡraʊnd/', phoneticUK: '/ˈpleɪɡraʊnd/',
    meaning: '操场', example: 'Play on the playground.', exampleTranslation: '在操场玩。',
    category: 'places', difficulty: 'easy', grade: '7', level: 'middle', image: '🏃'
  },
  {
    id: 'pleasant', word: 'pleasant', phoneticUS: '/ˈplezənt/', phoneticUK: '/ˈplezənt/',
    meaning: '令人愉快的', example: 'A pleasant day.', exampleTranslation: '愉快的一天。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'please', word: 'please', phoneticUS: '/pliːz/', phoneticUK: '/pliːz/',
    meaning: '请', example: 'Please help.', exampleTranslation: '请帮忙。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '🙏'
  },
  {
    id: 'pleased', word: 'pleased', phoneticUS: '/pliːzd/', phoneticUK: '/pliːzd/',
    meaning: '高兴的', example: 'I am pleased.', exampleTranslation: '我很高兴。',
    category: 'emotions', difficulty: 'medium', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'pleasure', word: 'pleasure', phoneticUS: '/ˈpleʒər/', phoneticUK: '/ˈpleʒə/',
    meaning: '快乐', example: 'My pleasure.', exampleTranslation: '我的荣幸。',
    category: 'emotions', difficulty: 'medium', grade: '9', level: 'middle', image: '😊'
  },
  {
    id: 'plenty', word: 'plenty', phoneticUS: '/ˈplenti/', phoneticUK: '/ˈplenti/',
    meaning: '大量的', example: 'Plenty of time.', exampleTranslation: '大量时间。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📈'
  },
  {
    id: 'pocket', word: 'pocket', phoneticUS: '/ˈpɑkɪt/', phoneticUK: '/ˈpɒkɪt/',
    meaning: '口袋', example: 'Put it in your pocket.', exampleTranslation: '放进口袋。',
    category: 'clothes', difficulty: 'easy', grade: '8', level: 'middle', image: '👖'
  },
  {
    id: 'poem', word: 'poem', phoneticUS: '/ˈpoʊəm/', phoneticUK: '/ˈpəʊɪm/',
    meaning: '诗歌', example: 'Read a poem.', exampleTranslation: '读诗。',
    category: 'hobbies', difficulty: 'medium', grade: '9', level: 'middle', image: '📜'
  },
  {
    id: 'point', word: 'point', phoneticUS: '/pɔɪnt/', phoneticUK: '/pɔɪnt/',
    meaning: '点；指出', example: 'Point to it.', exampleTranslation: '指向它。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '👆'
  },
  {
    id: 'police', word: 'police', phoneticUS: '/pəˈliːs/', phoneticUK: '/pəˈliːs/',
    meaning: '警察', example: 'Call the police.', exampleTranslation: '叫警察。',
    category: 'society', difficulty: 'easy', grade: '7', level: 'middle', image: '👮'
  },
  {
    id: 'polite', word: 'polite', phoneticUS: '/pəˈlaɪt/', phoneticUK: '/pəˈlaɪt/',
    meaning: '礼貌的', example: 'Be polite.', exampleTranslation: '要有礼貌。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '🙏'
  },
  {
    id: 'pollution', word: 'pollution', phoneticUS: '/pəˈluːʃn/', phoneticUK: '/pəˈluːʃn/',
    meaning: '污染', example: 'Reduce pollution.', exampleTranslation: '减少污染。',
    category: 'nature', difficulty: 'hard', grade: '9', level: 'middle', image: '🏭'
  },
  {
    id: 'pool', word: 'pool', phoneticUS: '/puːl/', phoneticUK: '/puːl/',
    meaning: '池塘；游泳池', example: 'Swim in the pool.', exampleTranslation: '在泳池游泳。',
    category: 'sports', difficulty: 'easy', grade: '8', level: 'middle', image: '🏊'
  },
  {
    id: 'poor', word: 'poor', phoneticUS: '/pʊr/', phoneticUK: '/pʊə/',
    meaning: '贫穷的', example: 'Help poor people.', exampleTranslation: '帮助穷人。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🤝'
  },
  {
    id: 'pop', word: 'pop', phoneticUS: '/pɑp/', phoneticUK: '/pɒp/',
    meaning: '流行音乐', example: 'Pop music.', exampleTranslation: '流行音乐。',
    category: 'hobbies', difficulty: 'easy', grade: '8', level: 'middle', image: '🎵'
  },
  {
    id: 'popular', word: 'popular', phoneticUS: '/ˈpɑpjələr/', phoneticUK: '/ˈpɒpjələ/',
    meaning: '流行的', example: 'Popular song.', exampleTranslation: '流行歌曲。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '⭐'
  },
  {
    id: 'population', word: 'population', phoneticUS: '/ˈpɑpjəˈleɪʃn/', phoneticUK: '/ˈpɒpjəˈleɪʃn/',
    meaning: '人口', example: 'Large population.', exampleTranslation: '大量人口。',
    category: 'society', difficulty: 'medium', grade: '9', level: 'middle', image: '👥'
  },
  {
    id: 'port', word: 'port', phoneticUS: '/pɔrt/', phoneticUK: '/pɔt/',
    meaning: '港口', example: 'Ship port.', exampleTranslation: '船港。',
    category: 'travel', difficulty: 'medium', grade: '9', level: 'middle', image: '⚓'
  },
  {
    id: 'pose', word: 'pose', phoneticUS: '/poʊz/', phoneticUK: '/pəʊz/',
    meaning: '姿势', example: 'Take a pose.', exampleTranslation: '摆姿势。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📸'
  },
  {
    id: 'position', word: 'position', phoneticUS: '/pəˈzɪʃn/', phoneticUK: '/pəˈzɪʃn/',
    meaning: '位置', example: 'Find the position.', exampleTranslation: '找到位置。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📍'
  },
  {
    id: 'possible', word: 'possible', phoneticUS: '/ˈpɑsəbl/', phoneticUK: '/ˈpɒsəbl/',
    meaning: '可能的', example: 'It is possible.', exampleTranslation: '这是可能的。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '✅'
  },
  {
    id: 'post', word: 'post', phoneticUS: '/poʊst/', phoneticUK: '/pəʊst/',
    meaning: '邮寄；帖子', example: 'Post a letter.', exampleTranslation: '邮寄信。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '📮'
  },
  {
    id: 'postcard', word: 'postcard', phoneticUS: '/ˈpoʊstkɑrd/', phoneticUK: '/ˈpəʊstkɑd/',
    meaning: '明信片', example: 'Send a postcard.', exampleTranslation: '寄明信片。',
    category: 'daily_life', difficulty: 'easy', grade: '8', level: 'middle', image: '💌'
  },
  {
    id: 'postman', word: 'postman', phoneticUS: '/ˈpoʊstmən/', phoneticUK: '/ˈpəʊstmən/',
    meaning: '邮递员', example: 'The postman comes.', exampleTranslation: '邮递员来了。',
    category: 'jobs', difficulty: 'medium', grade: '9', level: 'middle', image: '📮'
  },
  {
    id: 'pot', word: 'pot', phoneticUS: '/pɑt/', phoneticUK: '/pɒt/',
    meaning: '锅', example: 'Cook with a pot.', exampleTranslation: '用锅做饭。',
    category: 'daily_life', difficulty: 'easy', grade: '8', level: 'middle', image: '🍲'
  },
  {
    id: 'potato', word: 'potato', phoneticUS: '/pəˈteɪtoʊ/', phoneticUK: '/pəˈteɪtəʊ/',
    meaning: '土豆', example: 'Eat potatoes.', exampleTranslation: '吃土豆。',
    category: 'food', difficulty: 'easy', grade: '7', level: 'middle', image: '🥔'
  },
  {
    id: 'pound', word: 'pound', phoneticUS: '/paʊnd/', phoneticUK: '/paʊnd/',
    meaning: '英镑；磅', example: 'Five pounds.', exampleTranslation: '五英镑。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '💰'
  },
  {
    id: 'practice', word: 'practice', phoneticUS: '/ˈpræktɪs/', phoneticUK: '/ˈpræktɪs/',
    meaning: '练习', example: 'Practice makes perfect.', exampleTranslation: '熟能生巧。',
    category: 'actions', difficulty: 'easy', grade: '7', level: 'middle', image: '💪'
  },
  {
    id: 'praise', word: 'praise', phoneticUS: '/preɪz/', phoneticUK: '/preɪz/',
    meaning: '赞扬', example: 'Praise good work.', exampleTranslation: '赞扬好的工作。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '👏'
  },
  {
    id: 'price', word: 'price', phoneticUS: '/praɪs/', phoneticUK: '/praɪs/',
    meaning: '价格', example: 'What is the price?', exampleTranslation: '价格是多少？',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '💰'
  },
  {
    id: 'pride', word: 'pride', phoneticUS: '/praɪd/', phoneticUK: '/praɪd/',
    meaning: '骄傲', example: 'Take pride in.', exampleTranslation: '为...感到骄傲。',
    category: 'emotions', difficulty: 'medium', grade: '9', level: 'middle', image: '🏆'
  },
  {
    id: 'primary', word: 'primary', phoneticUS: '/ˈpraɪmeri/', phoneticUK: '/ˈpraɪməri/',
    meaning: '主要的；小学的', example: 'Primary school.', exampleTranslation: '小学。',
    category: 'school', difficulty: 'medium', grade: '8', level: 'middle', image: '🏫'
  },
  {
    id: 'prince', word: 'prince', phoneticUS: '/prɪns/', phoneticUK: '/prɪns/',
    meaning: '王子', example: 'A kind prince.', exampleTranslation: '善良的王子。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '👑'
  },
  {
    id: 'princess', word: 'princess', phoneticUS: '/ˈprɪnsəs/', phoneticUK: '/ˈprɪnsəs/',
    meaning: '公主', example: 'Beautiful princess.', exampleTranslation: '美丽的公主。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '👸'
  },
  {
    id: 'print', word: 'print', phoneticUS: '/prɪnt/', phoneticUK: '/prɪnt/',
    meaning: '打印', example: 'Print the document.', exampleTranslation: '打印文件。',
    category: 'actions', difficulty: 'easy', grade: '8', level: 'middle', image: '🖨️'
  },
  {
    id: 'printer', word: 'printer', phoneticUS: '/ˈprɪntər/', phoneticUK: '/ˈprɪntə/',
    meaning: '打印机', example: 'Use the printer.', exampleTranslation: '用打印机。',
    category: 'technology', difficulty: 'medium', grade: '9', level: 'middle', image: '🖨️'
  },
  {
    id: 'prize', word: 'prize', phoneticUS: '/praɪz/', phoneticUK: '/praɪz/',
    meaning: '奖品', example: 'Win a prize.', exampleTranslation: '获奖。',
    category: 'abstract', difficulty: 'easy', grade: '8', level: 'middle', image: '🏆'
  },
  {
    id: 'probably', word: 'probably', phoneticUS: '/ˈprɑbəbli/', phoneticUK: '/ˈprɒbəbli/',
    meaning: '可能', example: 'Probably true.', exampleTranslation: '可能是真的。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '🤔'
  },
  {
    id: 'problem', word: 'problem', phoneticUS: '/ˈprɑbləm/', phoneticUK: '/ˈprɒbləm/',
    meaning: '问题', example: 'Solve the problem.', exampleTranslation: '解决问题。',
    category: 'abstract', difficulty: 'easy', grade: '7', level: 'middle', image: '❓'
  },
  {
    id: 'program', word: 'program', phoneticUS: '/ˈproʊɡræm/', phoneticUK: '/ˈprəʊɡræm/',
    meaning: '程序；节目', example: 'Watch a program.', exampleTranslation: '看节目。',
    category: 'technology', difficulty: 'medium', grade: '8', level: 'middle', image: '📺'
  },
  {
    id: 'progress', word: 'progress', phoneticUS: '/ˈprɑɡres/', phoneticUK: '/ˈprəʊɡres/',
    meaning: '进步', example: 'Make progress.', exampleTranslation: '取得进步。',
    category: 'abstract', difficulty: 'medium', grade: '8', level: 'middle', image: '📈'
  },
  {
    id: 'promise', word: 'promise', phoneticUS: '/ˈprɑmɪs/', phoneticUK: '/ˈprɒmɪs/',
    meaning: '承诺', example: 'Make a promise.', exampleTranslation: '做出承诺。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '🤝'
  },
  {
    id: 'protect', word: 'protect', phoneticUS: '/prəˈtekt/', phoneticUK: '/prəˈtekt/',
    meaning: '保护', example: 'Protect nature.', exampleTranslation: '保护自然。',
    category: 'actions', difficulty: 'medium', grade: '8', level: 'middle', image: '🛡️'
  },
  {
    id: 'produce', word: 'produce', phoneticUS: '/prəˈduːs/', phoneticUK: '/prəˈdjuːs/',
    meaning: '生产', example: 'Produce food.', exampleTranslation: '生产食物。',
    category: 'actions', difficulty: 'medium', grade: '9', level: 'middle', image: '🏭'
  },
  {
    id: 'product', word: 'product', phoneticUS: '/ˈprɑdʌkt/', phoneticUK: '/ˈprɒdʌkt/',
    meaning: '产品', example: 'New product.', exampleTranslation: '新产品。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📦'
  },
  {
    id: 'program', word: 'program', phoneticUS: '/ˈproʊɡræm/', phoneticUK: '/ˈprəʊɡræm/',
    meaning: '计划；节目', example: 'Education program.', exampleTranslation: '教育计划。',
    category: 'abstract', difficulty: 'medium', grade: '9', level: 'middle', image: '📋'
  },
];

export default vocabularyOZ;